import { useEmployeeService } from 'domain/shared/employee';
import useCareerDevelopmentReviewService from 'domain/people/career/development/shared/careerDevelopmentReviewService';

const useCareerReviewService = () => {
  const { getById } = useEmployeeService();
  const { getCareerDevelopmentNextReviewDate } = useCareerDevelopmentReviewService();

  const getCareerReviewData = async (employeeId: string) => {
    const [nextReviewData, employeeData] = await Promise.all([
      getCareerDevelopmentNextReviewDate(employeeId),
      getById(employeeId),
    ]);

    return {
      nextReviewDate: nextReviewData?.date,
      careerDevelopmentEvaluationMode: employeeData?.careerDevelopmentEvaluationMode,
    };
  };

  return {
    getCareerReviewData,
  };
};

export default useCareerReviewService;
